import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Container, Row, Col, Tab, Tabs } from 'react-bootstrap';

//custom component

import Footer from 'Components/Footer';
import Back from 'assets/icon/back.png';
import Service from 'assets/icon/profile.png';
import TabsIcon from '../Components/layout/TabsIcon';
import DataProfile from '../Components/Profile/Data';
import Dashboard from '../Components/Profile/Dashboard';

//api
import { LoadProfile } from 'actions/user/index';
import Avatar from 'antd/lib/avatar/avatar';

export default function Index() {
  const [key, setKey] = useState('DataProfile');

  const history = useHistory();
  const dispatch = useDispatch();

  const [Data, setData] = useState({
    Username: null,
    Active: false,
    Employee: null,
  });

  const [User, setUser] = useState(null);

  useEffect(() => {
    GetProfile();
  }, []);

  function closePackage() {
    history.push(`/`);
  }

  function GetProfile(){
    const params = {
      isDashboard: true
    }
    dispatch(LoadProfile(params)).then(response => {
      const profile = response.data.data
      setData({
        UserId: profile.id,
        Username: profile.username,
        Employee: profile.employee,
        Active: profile.active,
        Avatar : profile.employee && profile.employee.avatar
      });
      setUser(response.data)
    }).catch(e => {

    })
  }

  return (
    <>
      
      <Container fluid className="package-container Staff Profile bg-mrk">
        {/* staff เอาไว้ใช้ style grid  , Profile เอาไว้ใช้ scss ส่วน profile เพิ่มเติม */}
        <div className="package">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={Service} />
                  <b>โปรไฟล์</b>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePackage}
                >
                  <span aria-hidden="true">X</span>
                </button>
              </div>
              <div className="modal-header-mobile">
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closePackage}
                >
                  <img src={Back} />
                </button>
                <h5 className="modal-title" id="exampleModalLabel">
                  <img className="logo pr-2" src={Service} />
                  <b>โปรไฟล์</b>
                </h5>
              </div>
              <div className="modal-body">
                <Row className="g-0 tabsicon justify-content-center ">
                  <TabsIcon />
                </Row>
                <Row className="g-0 justify-content-center Staff-tabs">
                  <Col className="justify-content-start  ">
                    <div className="box-typecar ">
                      <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                        className="mb-4"
                      >
                        <Tab eventKey="DataProfile" title="ข้อมูลส่วนตัว">
                          <Row className="Data-height justify-content-center">
                            <DataProfile data={Data} GetProfile={GetProfile}  />
                          </Row>
                        </Tab>
                        <Tab eventKey="Dashboard " title="Dashboard ">
                          <Row className="Data-height justify-content-center">
                            { User && <Dashboard User={User} /> }
                          </Row>
                        </Tab>
                      </Tabs>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
}
